(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('Subscribe', Subscribe);

    Subscribe.$inject = ['$resource'];

    function Subscribe ($resource) {
        var resourceUrl =  'api/subscribes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
